import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Col,
  Row,
  FormGroup,
  Input,
  Label,
  Button,
  // Container,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  CustomInput,
} from "reactstrap";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Select from "react-select";
import { IoIosClose } from "react-icons/io";
import TimeField from "react-simple-timefield";
import { Detector } from "react-detect-offline";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import Page from "../components/Page";
import * as Server from "../Server";
import { getAuthUser } from "../GeneralFunctions";
import PageSpinner from "../components/PageSpinner";
import "../styles/react-datetime.css";

export default class ScheduleEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      minDate: "",
      Camps: [],
      Teams: {},
      players: [],
      schedule: {},
      campId: "",
      campName: "",
      teamModel: false,
      assignments: [],
      showLoader: false,
      startTime: "",
      endTime: "",
      homeOrAway: "",
      homeOrAwayValue: null,
      locationDetail: "",
      uniform: "",
      arrivalTime: "",
      notes: "",
      firstTeamName: "",
      firstTeamId: "",
      secondTeamName: "",
      secondTeamId: "",
      scheduleEdit: false,
      scheduleId: "",
      scheduleDate: new Date(),
      location: "",
      latitude: "",
      longitude: "",
      meridiemStartDate: "PM",
      meridiemStartDateValue: {
        value: "PM",
        label: "PM",
      },
      meridiemEndDate: "PM",
      meridiemEndDateValue: {
        value: "PM",
        label: "PM",
      },
      notifyAll: false,
      selectedTeam: {},
      staffMemberId: "",
      newGame: true,
      eventName: "",
      extraLabel: "",
      repeats: "",
      repeatsValue: null,
      until: "",
      clubId: "",
      rangeDates: [],
      rangeDateModal: false,
      cancelScheduleModel: false,
      cancelScheduleNote: "",
      weeklyDay: [],
      weeklyDaysValue: [],
      selectedCamp: null,
      campOptions: [],
      teamOptions: [],
      selcetedTeamValue: null,
      matchId: "",
    };
  }

  handleChange = (address) => {
    this.setState({ address });
  };

  handleSelect = (address) => {
    geocodeByAddress(address)
      .then(
        (results) => (
          this.setState({
            location: results[0].formatted_address,
            address: results[0].formatted_address,
          }),
          getLatLng(results[0])
        )
      )
      .then((latLng) =>
        this.setState({
          latitude: latLng.lat,
          longitude: latLng.lng,
        })
      )
      .catch((error) => console.error("Error", error));
  };

  componentDidMount() {
    let user = getAuthUser();
    if (this.props.schedule) {
      if (this.props.schedule.until) {
        let startdate = new Date(this.props.schedule.startDate).getDate();
        let enddate = new Date(this.props.schedule.until).getDate();
        for (let index = startdate; index <= enddate; index++) {
          this.state.rangeDates.push(
            new Date(
              new Date(this.props.schedule.date).setDate(index)
            ).toDateString()
          );
        }
      }
      const homeOrAwayValue = this.props.schedule.homeOrAway
        ? this.props.schedule.homeOrAway === "home"
          ? {
              value: "home",
              label: "Home",
            }
          : {
              value: "away",
              label: "Away",
            }
        : null;
      const meridiemStartDateValue = this.props.schedule.startTime
        ? this.props.schedule.startTime.split(" ").splice(-1)[0] === "AM"
          ? {
              value: "AM",
              label: "AM",
            }
          : {
              value: "PM",
              label: "PM",
            }
        : {
            value: "PM",
            label: "PM",
          };
      const meridiemEndDateValue = this.props.schedule.endTime
        ? this.props.schedule.endTime.split(" ").splice(-1)[0] === "AM"
          ? {
              value: "AM",
              label: "AM",
            }
          : {
              value: "PM",
              label: "PM",
            }
        : {
            value: "PM",
            label: "PM",
          };
      this.setState(
        {
          newGame: this.props.schedule.newGame,
          eventName: this.props.schedule.eventName || "",
          extraLabel: this.props.schedule.extraLabel || "",
          repeats: this.props.schedule.repeats || "",
          until: this.props.schedule.until || "",
          scheduleEdit: true,
          scheduleId: this.props.schedule._id,
          scheduleDate: this.props.schedule.date,
          schedule: {
            location: this.props.schedule.location,
          },
          assignments: this.props.schedule.assignments.length
            ? this.props.schedule.assignments
            : [
                {
                  name: "",
                  player: "",
                  playerId: "default",
                },
              ],
          firstTeamName: this.props.schedule.firstTeam,
          secondTeamName: this.props.schedule.secondTeam || "",
          firstTeamId: this.props.schedule.firstTeamId,
          secondTeamId: this.props.schedule.secondTeamId || "",
          location: this.props.schedule.location,
          latitude: this.props.schedule.latitude,
          longitude: this.props.schedule.longitude,
          address: this.props.schedule.location,
          startTime: this.props.schedule.startTime.substr(
            0,
            this.props.schedule.startTime.indexOf(" ")
          ),
          endTime: this.props.schedule.endTime.substr(
            0,
            this.props.schedule.endTime.indexOf(" ")
          ),
          homeOrAway: this.props.schedule.homeOrAway || "",
          homeOrAwayValue,
          locationDetail: this.props.schedule.locationDetail,
          uniform: this.props.schedule.uniform || "",
          arrivalTime: this.props.schedule.arrivalTime,
          notes: this.props.schedule.notes,
          meridiemStartDate: this.props.schedule.startTime
            .split(" ")
            .splice(-1),
          meridiemEndDate: this.props.schedule.endTime.split(" ").splice(-1),
          meridiemStartDateValue,
          meridiemEndDateValue,
          matchId: this.props.schedule.matchId,
        },
        () => {
          this.getPlayers();
        }
      );
      this.getCamps(this.props.schedule.campId);
    } else {
      this.getCamps();
      this.state.assignments.push({
        name: "",
        player: "",
        playerId: "default",
      });
    }
    let date = new Date().toISOString();
    this.setState({
      minDate: date.split("T")[0],
      clubId: user.connectedUser._id,
    });
  }

  getCamps = async (campId) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "camp/web/list",
        method: "GET",
      });
      if (response && response.camps.length > 0) {
        let newCampId = campId ? campId : response.camps[0]._id;
        let campOptions = response.camps.map((camp) => ({
          label: camp.name,
          value: camp._id,
        }));
        let camp = response.camps.find((camp) => camp._id === newCampId);
        this.setState({
          showLoader: false,
          Camps: response.camps,
          campOptions,
          selectedCamp: {
            label: camp.name,
            value: camp._id,
          },
        });
        this.getTeams({ campId: newCampId });
      } else {
        this.setState({ showLoader: false });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getPlayers = async (event) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/schedule/players",
        method: "POST",
        data: {
          teamId: this.state.firstTeamId,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          players: response.players,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getTeams = async (event) => {
    // if (event && !event.campId) event.persist();
    try {
      let campId = event.campId ? event.campId : event.target.value;
      let camp = this.state.Camps.find((camp) => camp._id === campId);
      this.setState({ showLoader: true, camp });
      let response = await Server.request({
        url: "rushsoccer/camp/teamlist",
        method: "POST",
        data: { teamIds: camp.teams && camp.teams.length ? camp.teams : [] },
      });
      if (response) {
        if (!event.campId) {
          if (this.props.schedule && camp._id !== this.state.campId) {
            this.setState({ assignments: [] });
            this.state.assignments.push({
              name: "",
              player: "",
              playerId: "default",
            });
          }
        }
        let teamOptions = response.teams.map((team) => ({
          label: team.name,
          value: team._id,
        }));
        if (event.campId) {
          let team = response.teams.find(
            (team) => team._id === this.state.firstTeamId
          );
          let selcetedTeamValue = team
            ? {
                label: team.name,
                value: team._id,
              }
            : null;
          this.setState({
            showLoader: false,
            campId: camp._id,
            campName: camp.name,
            Teams: response.teams,
            teamOptions,
            selcetedTeamValue,
          });
        } else {
          this.setState({
            showLoader: false,
            campId: camp._id,
            campName: camp.name,
            Teams: response.teams,
            firstTeamId: "",
            firstTeamName: "",
            secondTeamId: "",
            secondTeamName: "",
            teamOptions,
            selcetedTeamValue: null,
          });
        }
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addRemoveAssignment = (isRemoved, index) => {
    if (isRemoved && index === 0) {
      return;
    }
    if (isRemoved && index >= 1) {
      this.state.assignments.splice(index, 1);
    } else {
      this.state.assignments.push({
        name: "",
        player: "",
        playerId: "default",
      });
    }
    this.setState({ showLoader: false });
  };

  createAndAddSchedule = async (event) => {
    event.preventDefault();
    try {
      if (this.state.newGame) {
        if (!this.state.selcetedTeamValue || !this.state.secondTeamName) {
          this.notificationSystem.addNotification({
            message: "Please select the teams",
            level: "error",
          });
          return;
        }
        this.setState({ showLoader: true });
        let playerIds = this.state.players.map((player) => player.child._id);
        let response = await Server.request({
          url: "rushsoccer/createschedule",
          method: "POST",
          data: {
            clubId: this.state.clubId,
            newGame: this.state.newGame,
            date: new Date(this.state.scheduleDate).setUTCHours(12, 0, 0, 0),
            campId: this.state.campId,
            campName: this.state.campName,
            firstTeam: this.state.firstTeamName,
            firstTeamId: this.state.firstTeamId,
            secondTeam: this.state.secondTeamName,
            location: this.state.location,
            latitude: this.state.latitude,
            longitude: this.state.longitude,
            assignments:
              this.state.assignments[0].name === "" &&
              this.state.assignments[0].player === ""
                ? []
                : this.state.assignments,
            everyOne: playerIds,
            notReplied: playerIds,
            nonPlayers: this.state.selectedTeam.staffMemberId,
            nonPlayersNotReplied: this.state.selectedTeam.staffMemberId,
            startTime:
              this.state.startTime.length > 0
                ? this.state.startTime.concat(
                    " " + this.state.meridiemStartDate
                  )
                : "",
            endTime:
              this.state.endTime.length > 0
                ? this.state.endTime.concat(" " + this.state.meridiemEndDate)
                : "",
            homeOrAway: this.state.homeOrAway,
            locationDetail: this.state.locationDetail,
            uniform: this.state.uniform,
            arrivalTime: this.state.arrivalTime,
            notes: this.state.notes,
            notifyAll: this.state.notifyAll,
            matchId: this.state.matchId,
          },
        });
        if (response) {
          this.setState(
            {
              showLoader: false,
              schedule: {
                location: "",
              },
              assignments: [
                {
                  name: "",
                  player: "",
                  playerId: "default",
                },
              ],
              startTime: "",
              endTime: "",
              homeOrAway: "",
              firstTeamName: "",
              secondTeamName: "",
              locationDetail: "",
              uniform: "",
              arrivalTime: "",
              notes: "",
              notifyAll: false,
              firstTeamId: "",
              secondTeamId: "",
              scheduleDate: new Date(),
              location: "",
              address: "",
              meridiemStartDate: "PM",
              meridiemEndDate: "PM",
              matchId: "",
            },
            () => {
              this.getCamps();
            }
          );
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
        }
      } else {
        if (!this.state.firstTeamName) {
          this.notificationSystem.addNotification({
            message: "Please select the teams",
            level: "error",
          });
          return;
        }
        this.setState({ showLoader: true });
        let playerIds = this.state.players.map((player) => player.child._id);
        let response = await Server.request({
          url: "rushsoccer/createschedule",
          method: "POST",
          data: {
            clubId: this.state.clubId,
            newGame: this.state.newGame,
            eventName: this.state.eventName,
            extraLabel: this.state.extraLabel,
            repeats: this.state.repeats,
            until: new Date(this.state.until).setUTCHours(12, 0, 0, 0),
            date: new Date(this.state.scheduleDate).setUTCHours(12, 0, 0, 0),
            campId: this.state.campId,
            campName: this.state.campName,
            firstTeam: this.state.firstTeamName,
            firstTeamId: this.state.firstTeamId,
            location: this.state.location,
            latitude: this.state.latitude,
            longitude: this.state.longitude,
            everyOne: playerIds,
            notReplied: playerIds,
            nonPlayers: this.state.selectedTeam.staffMemberId,
            nonPlayersNotReplied: this.state.selectedTeam.staffMemberId,
            startTime:
              this.state.startTime.length > 0
                ? this.state.startTime.concat(
                    " " + this.state.meridiemStartDate
                  )
                : "",
            endTime:
              this.state.endTime.length > 0
                ? this.state.endTime.concat(" " + this.state.meridiemEndDate)
                : "",
            locationDetail: this.state.locationDetail,
            arrivalTime: this.state.arrivalTime,
            notes: this.state.notes,
            notifyAll: this.state.notifyAll,
            weeklyDay: this.state.weeklyDay,
            matchId: this.state.matchId,
          },
        });
        if (response) {
          this.setState(
            {
              showLoader: false,
              newGame: true,
              eventName: "",
              extraLabel: "",
              repeats: "",
              until: "",
              schedule: {
                location: "",
              },
              startTime: "",
              endTime: "",
              firstTeamName: "",
              locationDetail: "",
              arrivalTime: "",
              notes: "",
              notifyAll: false,
              firstTeamId: "",
              scheduleDate: new Date(),
              location: "",
              address: "",
              meridiemStartDate: "PM",
              meridiemEndDate: "PM",
              matchId: "",
            },
            () => {
              this.getCamps();
            }
          );
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
        }
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  createSchedule = async (event) => {
    event.preventDefault();
    try {
      if (this.state.newGame) {
        if (!this.state.selcetedTeamValue || !this.state.secondTeamName) {
          this.notificationSystem.addNotification({
            message: "Please select the teams",
            level: "error",
          });
          return;
        }
        this.setState({ showLoader: true });
        let playerIds = this.state.players.map((player) => player.child._id);
        let response = await Server.request({
          url: "rushsoccer/createschedule",
          method: "POST",
          data: {
            clubId: this.state.clubId,
            newGame: this.state.newGame,
            date: new Date(this.state.scheduleDate).setUTCHours(12, 0, 0, 0),
            campId: this.state.campId,
            campName: this.state.campName,
            firstTeam: this.state.firstTeamName,
            firstTeamId: this.state.firstTeamId,
            secondTeam: this.state.secondTeamName,
            location: this.state.location,
            latitude: this.state.latitude,
            longitude: this.state.longitude,
            assignments:
              this.state.assignments[0].name === "" &&
              this.state.assignments[0].player === ""
                ? []
                : this.state.assignments,
            everyOne: playerIds,
            notReplied: playerIds,
            nonPlayers: this.state.selectedTeam.staffMemberId,
            nonPlayersNotReplied: this.state.selectedTeam.staffMemberId,
            startTime:
              this.state.startTime.length > 0
                ? this.state.startTime.concat(
                    " " + this.state.meridiemStartDate
                  )
                : "",
            endTime:
              this.state.endTime.length > 0
                ? this.state.endTime.concat(" " + this.state.meridiemEndDate)
                : "",
            homeOrAway: this.state.homeOrAway,
            locationDetail: this.state.locationDetail,
            uniform: this.state.uniform,
            arrivalTime: this.state.arrivalTime,
            notes: this.state.notes,
            notifyAll: this.state.notifyAll,
            matchId: this.state.matchId,
          },
        });
        if (response) {
          this.setState({ showLoader: false });
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
          this.closeEdit();
        }
      } else {
        if (!this.state.firstTeamName) {
          this.notificationSystem.addNotification({
            message: "Please select the teams",
            level: "error",
          });
          return;
        }
        this.setState({ showLoader: true });
        let playerIds = this.state.players.map((player) => player.child._id);
        let response = await Server.request({
          url: "rushsoccer/createschedule",
          method: "POST",
          data: {
            clubId: this.state.clubId,
            newGame: this.state.newGame,
            eventName: this.state.eventName,
            extraLabel: this.state.extraLabel,
            repeats: this.state.repeats,
            until: new Date(this.state.until).setUTCHours(12, 0, 0, 0),
            date: new Date(this.state.scheduleDate).setUTCHours(12, 0, 0, 0),
            campId: this.state.campId,
            campName: this.state.campName,
            firstTeam: this.state.firstTeamName,
            firstTeamId: this.state.firstTeamId,
            location: this.state.location,
            latitude: this.state.latitude,
            longitude: this.state.longitude,
            everyOne: playerIds,
            notReplied: playerIds,
            nonPlayers: this.state.selectedTeam.staffMemberId,
            nonPlayersNotReplied: this.state.selectedTeam.staffMemberId,
            startTime:
              this.state.startTime.length > 0
                ? this.state.startTime.concat(
                    " " + this.state.meridiemStartDate
                  )
                : "",
            endTime:
              this.state.endTime.length > 0
                ? this.state.endTime.concat(" " + this.state.meridiemEndDate)
                : "",
            locationDetail: this.state.locationDetail,
            arrivalTime: this.state.arrivalTime,
            notes: this.state.notes,
            notifyAll: this.state.notifyAll,
            weeklyDay: this.state.weeklyDay,
            matchId: this.state.matchId,
          },
        });
        if (response) {
          this.setState({ showLoader: false });
          this.notificationSystem.addNotification({
            message: response.message,
            level: "success",
          });
          this.closeEdit();
        }
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  selectAssignment = (event, index, type) => {
    event.persist();
    if (this.state.assignments[index]) {
      if (type === "text") {
        this.state.assignments.map((assignment, assignmentIndex) => {
          if (assignmentIndex === index) {
            assignment.name = event.target.value;
          }
          return assignment;
        });
      } else {
        this.state.assignments.map((assignment, assignmentIndex) => {
          if (assignmentIndex === index) {
            let player = this.state.players.find(
              (player) => player.child._id === event.target.value
            );
            let playerName =
              player.child.data.name ||
              `${player.child.data.firstName} ${player.child.data.lastName}`;
            assignment.player = playerName;
            assignment.playerId = player.child._id;
          }
          return assignment;
        });
      }
    } else {
      if (type === "text") {
        this.state.assignments.push({
          name: event.target.value,
          player: "",
          playerId: "",
        });
      } else {
        let player = this.state.players.find(
          (player) => player.child._id === event.target.value
        );
        this.state.assignments.push({
          name: "",
          player:
            player.child.data.name ||
            `${player.child.data.firstName} ${player.child.data.lastName}`,
          playerId: player.child._id,
        });
      }
    }
    this.setState({ showLoader: false });
  };

  handleTeamChange = async (teamId) => {
    let team = this.state.Teams.find((team) => team._id === teamId);
    this.setState(
      {
        firstTeamName: team.name,
        firstTeamId: team._id,
        selectedTeam: team,
        gotSportTeamName: team.teamSettings.gotSportTeamName,
        homeOrAway: team.teamSettings.homeOrAway,
        uniform: team.teamSettings.uniform,
        arrivalTime: team.teamSettings.arrivalTime,
        selcetedTeamValue: {
          label: team.name,
          value: team._id,
        },
      },
      () => this.getPlayers()
    );
    if (this.props.schedule && this.state.firstTeamId !== team._id) {
      await this.setState({ assignments: [] });
      await this.state.assignments.push({
        name: "",
        player: "",
        playerId: "default",
      });
    }
  };

  closeEdit() {
    this.props.closeEditPage();
  }

  toggleTeamModel = (event) => {
    event.preventDefault();
    this.setState({
      teamModel: !this.state.teamModel,
    });
  };

  toggleCancelScheduleModel = (event) => {
    event.preventDefault();
    this.setState({
      cancelScheduleModel: !this.state.cancelScheduleModel,
      cancelScheduleNote: "",
    });
  };

  toggleRangeDateModal = (event) => {
    event.preventDefault();
    this.setState({
      rangeDateModal: !this.state.rangeDateModal,
    });
  };

  updateSchedule = async (event) => {
    event.preventDefault();
    let everyOne = [];
    let notReplied = [];
    let nonPlayers = [];
    let nonPlayersNotReplied = [];
    let playerIds = this.state.players.map((player) => player.child._id);
    if (this.props.schedule.firstTeamId === this.state.firstTeamId) {
      everyOne = this.props.schedule.everyOne;
      notReplied = this.props.schedule.notReplied;
      nonPlayers = this.props.schedule.nonPlayers;
      nonPlayersNotReplied = this.props.schedule.nonPlayersNotReplied;
    } else {
      everyOne = playerIds;
      notReplied = playerIds;
      nonPlayers = this.state.selectedTeam.staffMemberId;
      nonPlayersNotReplied = this.state.selectedTeam.staffMemberId;
    }
    try {
      let obj = {};
      if (this.state.newGame) {
        if (!this.state.selcetedTeamValue || !this.state.secondTeamName) {
          this.notificationSystem.addNotification({
            message: "Please select the teams",
            level: "error",
          });
          return;
        }
        obj = {
          newGame: this.state.newGame,
          scheduleId: this.state.scheduleId,
          date: new Date(this.state.scheduleDate).setUTCHours(12, 0, 0, 0),
          campId: this.state.campId,
          campName: this.state.campName,
          firstTeam: this.state.firstTeamName,
          firstTeamId: this.state.firstTeamId,
          secondTeam: this.state.secondTeamName,
          location: this.state.location,
          latitude: this.state.latitude,
          longitude: this.state.longitude,
          clubId: this.props.schedule.clubId,
          startTime:
            this.state.startTime.length > 0
              ? this.state.startTime.concat(" " + this.state.meridiemStartDate)
              : "",
          endTime:
            this.state.endTime.length > 0
              ? this.state.endTime.concat(" " + this.state.meridiemEndDate)
              : "",
          homeOrAway: this.state.homeOrAway,
          locationDetail: this.state.locationDetail,
          uniform: this.state.uniform,
          arrivalTime: this.state.arrivalTime,
          notes: this.state.notes,
          everyOne: everyOne,
          notReplied: notReplied,
          nonPlayers: nonPlayers,
          nonPlayersNotReplied: nonPlayersNotReplied,
          assignments:
            this.state.assignments[0].name === "" &&
            this.state.assignments[0].player === ""
              ? []
              : this.state.assignments,
          matchId: this.state.matchId,
          notifyAll: this.state.notifyAll,
        };
      } else {
        if (!this.state.firstTeamName) {
          this.notificationSystem.addNotification({
            message: "Please select the teams",
            level: "error",
          });
          return;
        }
        obj = {
          newGame: this.state.newGame,
          scheduleId: this.state.scheduleId,
          eventName: this.state.eventName,
          extraLabel: this.state.extraLabel,
          repeats: this.state.repeats,
          until: new Date(this.state.until).setUTCHours(12, 0, 0, 0),
          date: new Date(this.state.scheduleDate).setUTCHours(12, 0, 0, 0),
          campId: this.state.campId,
          campName: this.state.campName,
          firstTeam: this.state.firstTeamName,
          firstTeamId: this.state.firstTeamId,
          location: this.state.location,
          latitude: this.state.latitude,
          longitude: this.state.longitude,
          clubId: this.props.schedule.clubId,
          startTime: this.state.startTime.concat(
            " " + this.state.meridiemStartDate
          ),
          endTime: this.state.endTime.concat(" " + this.state.meridiemEndDate),
          locationDetail: this.state.locationDetail,
          arrivalTime: this.state.arrivalTime,
          notes: this.state.notes,
          everyOne: everyOne,
          notReplied: notReplied,
          nonPlayers: nonPlayers,
          nonPlayersNotReplied: nonPlayersNotReplied,
          ids: this.props.schedule.ids,
          matchId: this.state.matchId,
          notifyAll: this.state.notifyAll,
        };
      }
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/updateSchedule",
        method: "POST",
        data: obj,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEdit();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateFutureSchedule = async (event) => {
    event.preventDefault();
    try {
      let playerIds = this.state.players.map((player) => player.child._id);
      let obj = {
        date: this.state.scheduleDate,
        ids: this.props.schedule.ids,
        scheduleId: this.state.scheduleId,
      };
      if (this.props.schedule.firstTeamId !== this.state.firstTeamId) {
        Object.assign(obj, {
          everyOne: playerIds,
          notReplied: playerIds,
          mayBe: [],
          available: [],
          notAvailable: [],
          nonPlayers: this.state.selectedTeam.staffMemberId,
          nonPlayersNotReplied: this.state.selectedTeam.staffMemberId,
          nonPlayersMayBe: [],
          nonPlayersAvailable: [],
          nonPlayersNotAvailable: [],
        });
      }
      if (this.props.schedule.eventName !== this.state.eventName)
        Object.assign(obj, { eventName: this.state.eventName });
      if (this.props.schedule.extraLabel !== this.state.extraLabel)
        Object.assign(obj, { extraLabel: this.state.extraLabel });
      if (this.props.schedule.repeats !== this.state.repeats)
        Object.assign(obj, { repeats: this.state.repeats });
      if (this.props.schedule.until !== this.state.until)
        Object.assign(obj, {
          until: new Date(this.state.until).setUTCHours(12, 0, 0, 0),
        });
      if (this.props.schedule.date !== this.state.scheduleDate)
        Object.assign(obj, {
          previousDate: this.props.schedule.date,
          date: new Date(this.state.scheduleDate).setUTCHours(12, 0, 0, 0),
          updateDate: true,
        });
      if (this.props.schedule.campId !== this.state.campId)
        Object.assign(obj, { campId: this.state.campId });
      if (this.props.schedule.campName !== this.state.campName)
        Object.assign(obj, { campName: this.state.campName });
      if (this.props.schedule.firstTeam !== this.state.firstTeamName)
        Object.assign(obj, { firstTeam: this.state.firstTeamName });
      if (this.props.schedule.firstTeamId !== this.state.firstTeamId)
        Object.assign(obj, { firstTeamId: this.state.firstTeamId });
      if (this.props.schedule.location !== this.state.location)
        Object.assign(obj, { location: this.state.location });
      if (this.props.schedule.latitude !== this.state.latitude)
        Object.assign(obj, { latitude: this.state.latitude });
      if (this.props.schedule.longitude !== this.state.longitude)
        Object.assign(obj, { longitude: this.state.longitude });
      if (this.props.schedule.clubId !== this.state.schedule.clubId)
        Object.assign(obj, { clubId: this.state.clubId });
      if (this.props.schedule.locationDetail !== this.state.locationDetail)
        Object.assign(obj, { locationDetail: this.state.locationDetail });
      if (this.props.schedule.arrivalTime !== this.state.arrivalTime)
        Object.assign(obj, { arrivalTime: this.state.arrivalTime });
      if (this.props.schedule.notes !== this.state.notes)
        Object.assign(obj, { notes: this.state.notes });

      let startTime = this.props.schedule.startTime.substr(
        0,
        this.props.schedule.startTime.indexOf(" ")
      );
      let endTime = this.props.schedule.endTime.substr(
        0,
        this.props.schedule.endTime.indexOf(" ")
      );
      let meridiemStartDate = this.props.schedule.startTime
        .split(" ")
        .splice(-1);
      let meridiemEndDate = this.props.schedule.endTime.split(" ").splice(-1);
      if (startTime !== this.state.startTime)
        Object.assign(obj, {
          startTime: this.state.startTime.concat(
            " " + this.state.meridiemStartDate
          ),
        });
      if (endTime !== this.state.endTime)
        Object.assign(obj, {
          endTime: this.state.endTime.concat(" " + this.state.meridiemEndDate),
        });
      if (meridiemStartDate[0] !== this.state.meridiemStartDate[0])
        Object.assign(obj, {
          startTime: this.state.startTime.concat(
            " " + this.state.meridiemStartDate
          ),
        });
      if (meridiemEndDate[0] !== this.state.meridiemEndDate[0])
        Object.assign(obj, {
          endTime: this.state.endTime.concat(" " + this.state.meridiemEndDate),
        });

      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/updateFutureSchedule",
        method: "POST",
        data: obj,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEdit();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  cancelSchedule = async (event) => {
    event.preventDefault();
    try {
      this.setState({
        showLoader: true,
      });
      let response = await Server.request({
        url: "rushsoccer/schedule/cancel",
        method: "POST",
        data: {
          scheduleId: this.state.scheduleId,
          note: this.state.cancelScheduleNote,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
        });
        this.closeEdit();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title={this.props.scheduleEditKey}
          breadcrumbs={[{ name: this.props.scheduleEditKey, active: true }]}
        >
          <Form onSubmit={this.createSchedule}>
            <Card>
              <CardHeader>
                <h3 style={{ margin: "auto" }}>
                  {this.props.scheduleEditKey.replace("-", " ")}
                </h3>
              </CardHeader>
              <CardBody>
                {!this.state.scheduleEdit && (
                  <Row>
                    <Col xl={6} lg={12} md={12}>
                      <FormGroup>
                        <div style={{ display: "flex" }}>
                          <CustomInput
                            id="private"
                            type="radio"
                            label="New Game"
                            checked={this.state.newGame}
                            name="eventType"
                            onClick={(event) => {
                              this.setState({
                                newGame: true,
                              });
                            }}
                          />
                          <CustomInput
                            id="public"
                            type="radio"
                            label="New Event"
                            checked={!this.state.newGame}
                            name="eventType"
                            onClick={(event) => {
                              this.setState({
                                newGame: false,
                              });
                            }}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                {!this.state.newGame && (
                  <>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="eventName">Name of Event:</Label>
                          <Input
                            required
                            type="text"
                            name="eventName"
                            placeholder="Enter Event Name"
                            value={this.state.eventName || ""}
                            onChange={(event) =>
                              this.setState({
                                eventName: event.target.value,
                              })
                            }
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="extraLabel">Extra Label:</Label>
                          <Input
                            type="text"
                            name="extraLabel"
                            placeholder="Enter the Value"
                            value={this.state.extraLabel || ""}
                            onChange={(event) =>
                              this.setState({
                                extraLabel: event.target.value,
                              })
                            }
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </>
                )}
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <FormGroup>
                      <Label for="date">{"Date:"}</Label>
                      <Input
                        type="date"
                        name="date"
                        value={
                          this.state.scheduleDate.length > 0
                            ? new Date(this.state.scheduleDate)
                                .toISOString()
                                .substr(0, 10)
                            : ""
                        }
                        onChange={(event) =>
                          this.setState({ scheduleDate: event.target.value })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <FormGroup>
                      <div className="d-flex">
                        <div>
                          <Label for="StartTime">Start Time:</Label>
                          <div className="d-flex">
                            <TimeField
                              style={{ width: "75%" }}
                              value={this.state.startTime || ""}
                              onChange={(event, value) =>
                                this.setState({ startTime: value })
                              }
                              input={<Input type="text" required />}
                            />
                            <Select
                              className="ml-1 width100"
                              isSearchable={false}
                              value={this.state.meridiemStartDateValue}
                              options={[
                                {
                                  value: "PM",
                                  label: "PM",
                                },
                                {
                                  value: "AM",
                                  label: "AM",
                                },
                              ]}
                              onChange={(result) =>
                                this.setState({
                                  meridiemStartDateValue: result,
                                  meridiemStartDate: result.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="pl-3">
                          <Label for="End Time">End Time:</Label>
                          <div className="d-flex">
                            <TimeField
                              value={this.state.endTime || ""}
                              onChange={(event, value) =>
                                this.setState({ endTime: value })
                              }
                              input={<Input type="text" />}
                            />
                            <Select
                              className="ml-1 width100"
                              isSearchable={false}
                              value={this.state.meridiemEndDateValue}
                              options={[
                                {
                                  value: "PM",
                                  label: "PM",
                                },
                                {
                                  value: "AM",
                                  label: "AM",
                                },
                              ]}
                              onChange={(result) =>
                                this.setState({
                                  meridiemEndDateValue: result,
                                  meridiemEndDate: result.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                {!this.state.newGame && (
                  <>
                    {
                      !this.props.scheduleEdit ? (
                        <Row>
                          <Col xl={6} lg={12} md={12}>
                            <FormGroup>
                              <Label>Repeats:</Label>
                              <Select
                                isSearchable={false}
                                placeholder="Select the value"
                                value={this.state.repeatsValue}
                                options={[
                                  {
                                    value: "daily",
                                    label: "Daily",
                                  },
                                  {
                                    value: "weekly",
                                    label: "Weekly",
                                  },
                                ]}
                                onChange={(result) =>
                                  this.setState({
                                    repeatsValue: result,
                                    repeats: result.value,
                                  })
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      ) : null
                      // this.state.rangeDates.length
                      //   ? <Row>
                      //     <Col xl={6} lg={12} md={12}>
                      //       <FormGroup>
                      //         <Label>Repeats:</Label>
                      //         {this.state.rangeDates.map(rangeDate =>
                      //           <div>{new Date(this.state.scheduleDate).getDate() === new Date(rangeDate).getDate()
                      //             ? '*'
                      //             : null
                      //           }{rangeDate}
                      //           </div>
                      //         )}
                      //       </FormGroup>
                      //     </Col>
                      //   </Row>
                      //   : null
                    }
                    {
                      !this.props.scheduleEdit
                        ? (this.state.repeats === "daily" ||
                            this.state.repeats === "weekly") && (
                            <>
                              {this.state.repeats === "weekly" ? (
                                <Row>
                                  <Col xl={6} lg={12} md={12}>
                                    <FormGroup>
                                      <Label for="date">
                                        Select weekly day:
                                      </Label>
                                      <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={[
                                          { label: "Sunday", value: "Sunday" },
                                          { label: "Monday", value: "Monday" },
                                          {
                                            label: "Tuesday",
                                            value: "Tuesday",
                                          },
                                          {
                                            label: "Wednesday",
                                            value: "Wednesday",
                                          },
                                          {
                                            label: "Thursday",
                                            value: "Thursday",
                                          },
                                          { label: "Friday", value: "Friday" },
                                          {
                                            label: "Saturday",
                                            value: "Saturday",
                                          },
                                        ]}
                                        value={this.state.weeklyDaysValue}
                                        onChange={(result) => {
                                          let weeklyDays = result.map(
                                            (values) => values.value
                                          );
                                          this.setState({
                                            weeklyDaysValue: result,
                                            weeklyDay: weeklyDays,
                                          });
                                        }}
                                        className="basic-multi-select"
                                        // classNamePrefix="select"
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              ) : null}
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <FormGroup>
                                    <Label for="date">Until:</Label>
                                    <Input
                                      type="date"
                                      name="date"
                                      value={
                                        this.state.until.length > 0
                                          ? new Date(this.state.until)
                                              .toISOString()
                                              .substr(0, 10)
                                          : ""
                                      }
                                      onChange={(event) =>
                                        this.setState({
                                          until: event.target.value,
                                        })
                                      }
                                    ></Input>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </>
                          )
                        : null
                      // this.state.rangeDates.length
                      //   ? <Button
                      //     className="mr-5 mb-3"
                      //     onClick={(event) => this.toggleRangeDateModal(event)}
                      //   >
                      //     Change start/end dates
                      //   </Button>
                      //   : null
                    }
                  </>
                )}
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <FormGroup>
                      <Label>Events:</Label>
                      <Select
                        isSearchable={false}
                        placeholder="Select the value"
                        value={this.state.selectedCamp}
                        options={this.state.campOptions}
                        onChange={(result) =>
                          this.setState(
                            {
                              selectedCamp: result,
                            },
                            () =>
                              this.getTeams({ target: { value: result.value } })
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={6} lg={12} md={12}>
                    <Label
                      style={{ cursor: "pointer" }}
                      className="text-primary pt-5"
                      onClick={(event) => this.toggleTeamModel(event)}
                    >
                      All Teams
                    </Label>
                  </Col>
                </Row>
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <FormGroup>
                      <Label>Team:</Label>
                      <Select
                        isSearchable={false}
                        placeholder="Select Team"
                        value={this.state.selcetedTeamValue}
                        options={this.state.teamOptions}
                        onChange={(result) =>
                          this.handleTeamChange(result.value)
                        }
                      />
                      {this.state.newGame && (
                        <>
                          <Label className="mt-3">Opponent:</Label>
                          <Input
                            required
                            type="text"
                            name="opponent"
                            placeholder="Enter Team Name"
                            value={this.state.secondTeamName || ""}
                            onChange={(event) =>
                              this.setState({
                                secondTeamName: event.target.value,
                              })
                            }
                          ></Input>
                        </>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                {this.state.newGame && (
                  <>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label>Home or Away:</Label>
                          <Select
                            isSearchable={false}
                            placeholder="Select the value"
                            value={this.state.homeOrAwayValue}
                            options={[
                              {
                                value: "home",
                                label: "Home",
                              },
                              {
                                value: "away",
                                label: "Away",
                              },
                            ]}
                            onChange={(result) =>
                              this.setState({
                                homeOrAwayValue: result,
                                homeOrAway: result.value,
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="Uniform">Uniform:</Label>
                          <Input
                            type="text"
                            name="Uniform"
                            placeholder="Uniform"
                            value={this.state.uniform || ""}
                            onChange={(event) =>
                              this.setState({ uniform: event.target.value })
                            }
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </>
                )}
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <FormGroup>
                      <Label for="Arrival time">Arrival time:</Label>
                      <div className="d-flex">
                        <Input
                          type="number"
                          className="mr-2"
                          style={{ width: "40%" }}
                          name="Arrival time"
                          placeholder="Arrival time"
                          value={this.state.arrivalTime || ""}
                          onChange={(event) =>
                            event.target.value >= 0 && event.target.value <= 59
                              ? this.setState({
                                  arrivalTime: event.target.value,
                                })
                              : ""
                          }
                        ></Input>
                        <p
                          className="text-muted"
                          style={{ margin: "auto 0px" }}
                        >
                          minutes before the starting time
                        </p>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <FormGroup>
                      <Label>Location: </Label>
                      <Detector
                        render={({ online }) => (
                          <div className={online ? "normal" : "warning"}>
                            {online ? (
                              <div>
                                <PlacesAutocomplete
                                  value={this.state.address}
                                  onChange={this.handleChange}
                                  onSelect={this.handleSelect}
                                >
                                  {({
                                    getInputProps,
                                    suggestions,
                                    getSuggestionItemProps,
                                    loading,
                                  }) => (
                                    <div>
                                      <Input
                                        style={{ width: "100%" }}
                                        required
                                        {...getInputProps({
                                          placeholder: "Search Places ...",
                                          className: "location-search-input ",
                                        })}
                                      />
                                      <div className="autocomplete-dropdown-container">
                                        {loading && (
                                          <div className="addPadding">
                                            Loading...
                                          </div>
                                        )}
                                        {suggestions.map((suggestion) => {
                                          const className = suggestion.active
                                            ? "suggestion-item--active addPadding"
                                            : "suggestion-item addPadding";
                                          const style = suggestion.active
                                            ? {
                                                backgroundColor:
                                                  "rgba(0, 0, 0, 0.05)",
                                                cursor: "pointer",
                                              }
                                            : {
                                                backgroundColor: "#ffffff",
                                                cursor: "pointer",
                                              };
                                          return (
                                            <div
                                              {...getSuggestionItemProps(
                                                suggestion,
                                                {
                                                  className,
                                                  style,
                                                }
                                              )}
                                            >
                                              <span>
                                                {suggestion.description}
                                              </span>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </PlacesAutocomplete>
                              </div>
                            ) : (
                              <Input
                                type="text"
                                placeholder="You Are Offline"
                                value=""
                              ></Input>
                            )}
                          </div>
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <FormGroup>
                      <Label for="detail">Location Details:</Label>
                      <Input
                        type="text"
                        name="detail"
                        placeholder="Location Details"
                        value={this.state.locationDetail || ""}
                        onChange={(event) =>
                          this.setState({
                            locationDetail: event.target.value,
                          })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <FormGroup>
                      <Label for="Notes">Notes:</Label>
                      <Input
                        type="textarea"
                        name="Notes"
                        placeholder="Notes"
                        value={this.state.notes || ""}
                        onChange={(event) =>
                          this.setState({ notes: event.target.value })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                {this.state.newGame ? (
                  <Row>
                    <Col xl={6} lg={12} md={12}>
                      <FormGroup>
                        <Label for="matchId">Got Sport Match Id:</Label>
                        <Input
                          name="matchId"
                          placeholder="Enter Got Sport Match Id"
                          value={this.state.matchId || ""}
                          onChange={(event) =>
                            this.setState({ matchId: event.target.value })
                          }
                        ></Input>
                      </FormGroup>
                    </Col>
                  </Row>
                ) : null}
                <Row>
                  <Col xl={6} lg={12} md={12}>
                    <div className="ml-4">
                      <Input
                        type="checkbox"
                        style={{ width: "15px", height: "15px" }}
                        checked={this.state.notifyAll}
                        onChange={(event) =>
                          this.setState({ notifyAll: !this.state.notifyAll })
                        }
                      ></Input>
                      <Label>Notify Members</Label>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card className="mt-3">
              {this.state.newGame && (
                <>
                  <CardHeader>
                    <Row>
                      <Col style={{ marginBottom: 0, paddingLeft: 0 }}>
                        Assigments
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Row>
                        <Col sm={12} xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Assignment:</Label>
                            {this.state.assignments.map((assignment, index) => (
                              <Row key={index} className="mt-2">
                                <Col sm={12} md={3} lg={3} xl={3}>
                                  <Input
                                    name={`assignment-${index}`}
                                    placeholder="eg Bring Snacks, Stripe Field"
                                    type="text"
                                    value={assignment.name}
                                    style={{ width: 250 }}
                                    onChange={(event) =>
                                      this.selectAssignment(
                                        event,
                                        index,
                                        "text"
                                      )
                                    }
                                  />
                                </Col>
                                <Col sm={12} md={3} lg={3} xl={3}>
                                  <Input
                                    className="ml-2"
                                    required
                                    type="select"
                                    value={assignment.playerId}
                                    name={`selectPlayer-${index}`}
                                    onChange={(event) =>
                                      this.selectAssignment(
                                        event,
                                        index,
                                        "select"
                                      )
                                    }
                                  >
                                    <option disabled selected value="default">
                                      Select Player
                                    </option>
                                    {this.state.players &&
                                    this.state.players.length > 0
                                      ? this.state.players.map(
                                          (player, index) => (
                                            <option
                                              key={index}
                                              value={player.child._id}
                                            >
                                              {player.child.data.firstName +
                                                " " +
                                                player.child.data.lastName}
                                            </option>
                                          )
                                        )
                                      : ""}
                                  </Input>
                                </Col>
                                <Col sm={12} md={3} lg={3} xl={3}>
                                  <Button
                                    style={{ marginLeft: 10 }}
                                    onClick={() =>
                                      this.addRemoveAssignment(true, index)
                                    }
                                  >
                                    <IoIosClose size="20px" />
                                  </Button>
                                </Col>
                              </Row>
                            ))}
                          </FormGroup>
                        </Col>
                      </Row>
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          justifyContent: "center",
                          marginTop: 5,
                        }}
                      >
                        <Button onClick={() => this.addRemoveAssignment()}>
                          Add another
                        </Button>
                      </div>
                    </FormGroup>
                  </CardBody>
                </>
              )}
              <CardFooter>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                    marginTop: 5,
                  }}
                >
                  {this.state.scheduleEdit ? (
                    this.state.newGame ? (
                      <Button className="mr-5" onClick={this.updateSchedule}>
                        Update
                      </Button>
                    ) : (
                      <>
                        {/* {
                          this.state.rangeDates.length
                            ?
                            <Button className="mr-5" onClick={this.updateFutureSchedule}>
                              Update All Future
                            </Button>
                            : null
                        } */}
                        <Button className="mr-5" onClick={this.updateSchedule}>
                          Update
                        </Button>
                      </>
                    )
                  ) : (
                    <>
                      <Button
                        style={{ marginRight: 10 }}
                        className="mr-5"
                        type="submit"
                      >
                        Save
                      </Button>
                      <Button
                        className="mr-5"
                        onClick={this.createAndAddSchedule}
                      >
                        Save and create another one
                      </Button>
                    </>
                  )}
                  {this.state.scheduleEdit && (
                    <Button
                      className="mr-5"
                      onClick={(event) => this.toggleCancelScheduleModel(event)}
                    >
                      Cancel Schedule
                    </Button>
                  )}
                  <Button
                    className="float-right"
                    onClick={(e) => {
                      this.closeEdit();
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </CardFooter>
              {this.state.teamModel ? (
                <Modal
                  isOpen={this.state.teamModel}
                  toggle={(event) => this.toggleTeamModel(event)}
                  className="modal-md"
                >
                  <ModalHeader toggle={(event) => this.toggleTeamModel(event)}>
                    <Label>All Teams</Label>
                  </ModalHeader>
                  <ModalBody>
                    <div className="d-flex flex-wrap ">
                      {this.state.Teams && this.state.Teams.length > 0 ? (
                        this.state.Teams.map((team, index) => (
                          <Card
                            key={index}
                            className="d-flex justify-content-center mr-2"
                          >
                            <Label className="m-2 text-center">
                              {team.name}
                            </Label>
                          </Card>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No teams found
                          </td>
                        </tr>
                      )}
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="secondary"
                      onClick={(event) => this.toggleTeamModel(event)}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              ) : null}
              {this.state.rangeDateModal ? (
                <Modal
                  isOpen={this.state.rangeDateModal}
                  toggle={(event) => this.toggleRangeDateModal(event)}
                  className="modal-md"
                >
                  <ModalHeader
                    toggle={(event) => this.toggleRangeDateModal(event)}
                  >
                    <Label>Change Start/End Date</Label>
                  </ModalHeader>
                  <ModalBody>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label for="date">Start Date</Label>
                              <Input
                                required
                                type="date"
                                name="date"
                                value={
                                  this.state.scheduleDate.length > 0
                                    ? new Date(this.state.scheduleDate)
                                        .toISOString()
                                        .substr(0, 10)
                                    : ""
                                }
                                onChange={(event) =>
                                  this.setState({
                                    scheduleDate: event.target.value,
                                  })
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label for="until">End Date</Label>
                              <Input
                                required
                                type="date"
                                name="until"
                                value={
                                  this.state.until.length > 0
                                    ? new Date(this.state.until)
                                        .toISOString()
                                        .substr(0, 10)
                                    : ""
                                }
                                onChange={(event) =>
                                  this.setState({ until: event.target.value })
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="secondary"
                      onClick={(event) => this.toggleRangeDateModal(event)}
                    >
                      Save
                    </Button>
                    <Button
                      color="secondary"
                      onClick={(event) => this.toggleRangeDateModal(event)}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              ) : null}
              {this.state.cancelScheduleModel ? (
                <Modal
                  isOpen={this.state.cancelScheduleModel}
                  toggle={(event) => this.toggleCancelScheduleModel(event)}
                  className="modal-md"
                >
                  <ModalHeader
                    toggle={(event) => this.toggleCancelScheduleModel(event)}
                  >
                    <Label>Note:-</Label>
                  </ModalHeader>
                  <ModalBody>
                    <Label>Note:-</Label>
                    <Input
                      type="text"
                      required
                      placeholder="Enter note"
                      onChange={(event) => {
                        event.persist();
                        this.setState({
                          cancelScheduleNote: event.target.value,
                        });
                      }}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      type="submit"
                      onClick={(event) => this.cancelSchedule(event)}
                      color="secondary"
                      disabled={!this.state.cancelScheduleNote}
                    >
                      Cancel Schedule
                    </Button>
                    <Button
                      color="secondary"
                      onClick={(event) => this.toggleCancelScheduleModel(event)}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              ) : null}
            </Card>
          </Form>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
